import React from 'react';

const Card = ({ children, className = '' }: { children: React.ReactNode; className?: string }) => {
  return (
    <div className={['bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700', className].join(' ')}>
      {children}
    </div>
  );
};

export default Card;

